import pkg from '../../package.json'
import { isProductionEnv } from '@demo-system/commons/service/environment'

const { version } = pkg

const PROJECT_PART_LABELS = {
  meta: 'Meta',
  screens: 'Screens',
  modules: 'Modules',
  branding: 'Branding',
  integrations: 'Integrations',
  profileViewer: 'Profile Viewer',
  products: 'Products',
  triggers: 'Triggers',
}

const TEST_LAUNCH_URL = '//assets.adobedtm.com/ef7912a2f29c/5551523ff6e7/launch-79ab12bdc3c8-development.min.js'
const PRODUCTION_LAUNCH_URL = '//assets.adobedtm.com/ef7912a2f29c/5551523ff6e7/launch-4fcacb4d0f37.min.js'

const launchUrl = isProductionEnv() ? PRODUCTION_LAUNCH_URL : TEST_LAUNCH_URL

//
// Helpers for code-shortening
//

const sendEvent = (interactionName) => () => {
  window.dataLayer.toolInteraction = interactionName
  document.body.dispatchEvent(new CustomEvent('toolInteraction'))
}

const getter = (propName) => () => {
  if (!window.dataLayer) {
    console.error('Data Layer object not initialized.')
  }
  return window.dataLayer && window.dataLayer[propName]
}

const setter = (propName) => (value) => {
  if (!window.dataLayer) {
    console.error('Data Layer object not initialized.')
  }
  window.dataLayer[propName] = value
}

//
// Data Layer methods
//

const getUser = getter('userID')
const getProjectID = getter('projectID')

const setUser = setter('userID')

const setProject = (project) => {
  const { id, title, template } = project?.meta || {}
  window.dataLayer = {
    ...(window.dataLayer || {}),
    projectTitle: title,
    projectTemplate: template,
    projectID: id,
  }
}

const clearProject = () => {
  window.dataLayer = { ...(window.dataLayer || {}), projectTitle: '', projectTemplate: '', projectID: '' }
}

//
// Actions
//

const triggerToolStart = sendEvent('Builder:Launch')
const triggerCreateNewProject = sendEvent('Builder:New Project:Start')
const triggerOpenProject = sendEvent('Builder:Project:Open')
const triggerCopyProject = sendEvent('Builder:Project:Copy')
const triggerDeleteProject = sendEvent('Builder:Project:Delete')
const triggerRunProject = sendEvent('Builder:Project:Run')
const triggerUpdatePassword = sendEvent('Builder:Project:Password Updated')
const triggerUpdateAlias = sendEvent('Builder:Project:Alias Updated')
const triggerDeleteAlias = sendEvent('Builder:Project:Alias Deleted')
const triggerGenerateLink = sendEvent('Builder:Project:Link Generated')
const triggerUpdatePermissions = sendEvent('Builder:Project:Permissions Updated')
const triggerTransferProject = sendEvent('Builder:Project:Ownership Transferred')
const triggerOpenTranslateDialog = sendEvent('Builder:Project:Translate Opened')
const triggerTranslateProject = (language, locale) => {
  window.dataLayer.toolInteraction = `Builder:Project:Translated:${language}${locale ? `:${locale}` : ''}`
  document.body.dispatchEvent(new CustomEvent('toolInteraction'))
}

const triggerUpdateProjectPart = (partName) => {
  window.dataLayer.toolInteraction = `Builder:Project:${PROJECT_PART_LABELS[partName]} Updated`
  document.body.dispatchEvent(new CustomEvent('toolInteraction'))
}

//
// Initialization
//

const init = () => {
  window.dataLayer = {
    toolName: 'Builder',
    toolVersion: version,
    projectTitle: '',
    projectTemplate: '',
    userID: '',
    toolInteraction: '',
    projectID: '',
    workspaceName: '',
    workspaceID: '',
    jobName: '',
  }

  const script = document.createElement('script')
  script.src = launchUrl
  script.async = true
  document.body.appendChild(script)
}

export default {
  init,

  getUser,
  getProjectID,

  setUser,
  setProject,
  clearProject,

  triggerToolStart,
  triggerCreateNewProject,
  triggerOpenProject,
  triggerCopyProject,
  triggerDeleteProject,
  triggerRunProject,
  triggerUpdatePassword,
  triggerUpdateAlias,
  triggerDeleteAlias,
  triggerGenerateLink,
  triggerUpdatePermissions,
  triggerTransferProject,
  triggerOpenTranslateDialog,
  triggerTranslateProject,
  triggerUpdateProjectPart,
}
